import {FormLabel} from '../../form-features/labels/FormLabel';
import {ToggleBackground, ToggleHandle} from './ToggleFeatures';

export const toggleDirection = (direction) => {
    if (direction === 'right')
        return `
        flex-direction: row-reverse;
    `;
    else return ``;
};

export const toggleSize = (size) => {
    if (size === 'small')
        return `

        --toggle-width:             22px;
        --toggle-height:            12px;
        --toggle-handle:            8px;
        --toggle-handle-position:   2px;

        ${FormLabel} {
            font-size: var(--text-size-small);
            line-height: 12px;
        }
    `;
    else return ``;
};

export const toggleFeatureSetup = () => `
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding: 3px;
    position: relative;
    vertical-align: top;

    input {
        display: none;
    }
    ${FormLabel} {
        cursor: pointer;
    }
    input ~ ${ToggleBackground} {
        transition: 0.2s;
        ${ToggleHandle} {
            left: var(--toggle-handle-position);
        }
    }
    input:checked ~ ${ToggleBackground} {
        transition: 0.2s;
        background: var(--primary) none repeat scroll 0 0;
        ${ToggleHandle} {
            left: calc( (var(--toggle-width) -  var(--toggle-handle)) - var(--toggle-handle-position) );
        }
    }
    input ~ ${FormLabel}:hover {
        color: var(--primary);
    }
    input:checked ~ ${FormLabel} {
        color: var(--primary);
        &:hover {
            color: var(--primary-dark);
        }
    }
`;
